import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/auth.hook';
import { Skeleton } from '@/components/ui/skeleton';

interface AuthWrapperProps {
    children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
    const { checkAuthStatus, isLoading } = useAuth();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                // Check auth status và refresh token nếu cần
                await checkAuthStatus();
            } catch (error) {
                console.error('Auth initialization error:', error);
            } finally {
                setIsInitialized(true);
            }
        };

        initializeAuth();
    }, []); // Empty dependency để chỉ chạy 1 lần khi mount

    // Hiển thị loading chỉ khi đang loading và chưa initialized
    if (!isInitialized && isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <Skeleton className="h-[4rem] w-[4rem] rounded-full" />
            </div>
        );
    }

    // Render children ngay cả khi token hết hạn
    // Auth middleware sẽ handle redirect nếu cần
    return <>{children}</>;
}
